/** Date/time helpers for Lists client. */

export function formatDateKey(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseDateKey(key: string): Date {
  const [y, m, d] = key.split("-").map(n => parseInt(n, 10));
  return new Date(y!, (m ?? 1) - 1, d ?? 1);
}

export function minutesToTimeString(min: number): string {
  const h = Math.floor(min / 60) % 24;
  const m = min % 60;
  return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
}

export function timeStringToMinutes(str: string): number {
  const m = /^(\d{1,2}):?(\d{2})$/.exec(str.trim());
  if (!m) return 0;
  return parseInt(m[1]!, 10) * 60 + parseInt(m[2]!, 10);
}

export function roundTimeStringToStep(str: string, stepMin = 5): string {
  if (!str) return "";
  const total = timeStringToMinutes(str);
  const rounded = Math.round(total / stepMin) * stepMin;
  return minutesToTimeString(rounded);
}

export function formatTimeDisplay(min: number): string {
  return minutesToTimeString(min);
}

export function formatDateTimeDisplay(d: Date): string {
  return `${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`;
}

export function nowTimeString(): string {
  const d = new Date();
  return roundTimeStringToStep(
    `${d.getHours().toString().padStart(2, "0")}:${d.getMinutes().toString().padStart(2, "0")}`,
  );
}

export function todayKey(): string {
  return formatDateKey(new Date());
}

export function formatDateLong(d: Date): string {
  return d.toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function formatDayName(d: Date): string {
  return d.toLocaleDateString(undefined, {
    weekday: "long",
  });
}

export function formatDateOnly(d: Date): string {
  return d.toLocaleDateString(undefined, {
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

export function formatDurationShort(min: number): string {
  if (min < 60) return `${min}m`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
}
